import React from 'react';
import { Container, Navbar, NavbarBrand } from 'reactstrap';
import { PageTitle } from '@cordata/buffet';
import { useParams } from 'react-router-dom';

import Identity from '~/assets/identity.svg';

import Form from '~/components/CIT/Form';
import Seal from '~/components/CIT/Seal';
import { CitProvider } from '~/utils/cit/context';

const Cit = () => {
  const { state } = useParams();

  return (
    <>
      <Navbar color="primary" dark expand="md" className="mb-3 sticky-top" style={{ height: '56px' }}>
        <NavbarBrand>
          <img src={Identity} width={130} alt="Navigator - Cordata" className="mr-2" />
        </NavbarBrand>
      </Navbar>

      <Container>
        <PageTitle tag="h3">
          Crisis Intervention Contact Sheet
        </PageTitle>

        <CitProvider>
          <Form />

          <Seal state={state} />
        </CitProvider>
      </Container>
    </>
  );
};

export default Cit;
